export type JiraPresetType = 'push' | 'pull';

export type JiraTransform = 'csvToArray' | 'dateYMD' | 'bool';

export interface JiraPushField {
  src: 'column' | 'const';
  /** имя колонки таблицы (src=column) либо само значение (src=const) */
  value: string;
  transform?: JiraTransform;
  encrypt?: boolean;
}

export interface JiraPushConfig {
  fields: Record<string, JiraPushField>;
}

export interface JiraPullConfig {
  keyColumn: string;
  /** поле ответа Jira -> имя колонки таблицы */
  fields: Record<string, string>;
}

export interface JiraPreset {
  id: string;
  tableId: string;
  type: JiraPresetType;
  name: string;
  config: JiraPushConfig | JiraPullConfig;
  createdById: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateJiraPresetDto {
  name: string;
  type: JiraPresetType;
  config: JiraPushConfig | JiraPullConfig;
}

export interface UpdateJiraPresetDto {
  name: string;
  config: JiraPushConfig | JiraPullConfig;
}

export interface JiraPushResult {
  ok: boolean;
  key: string;
  sentFields: string[];
  encryptedFields: string[];
  skipped: string[];
}

export interface JiraPullResult {
  key: string;
  raw: Record<string, any>;
  mapped: Record<string, any>;
}

/** Поля тела setInfoToIssue. sensitive — по умолчанию включаем шифрование. */
export const JIRA_ISSUE_FIELDS: {
  name: string;
  label: string;
  required?: boolean;
  sensitive?: boolean;
  transform?: JiraTransform;
}[] = [
  { name: 'key', label: 'Ключ задачи', required: true },
  { name: 'dateOfIssueToTheTeam', label: 'Дата выдачи команде', transform: 'dateYMD' },
  { name: 'profile', label: 'Профиль' },
  { name: 'proxy', label: 'Прокси' },
  { name: 'antik', label: 'Антидетект' },
  { name: 'numberPhone', label: 'Номер телефона' },
  { name: 'linkToNumber', label: 'Ссылка на номер' },
  { name: 'numberLifespan', label: 'Срок жизни номера' },
  { name: 'emailApple', label: 'Email Apple' },
  { name: 'passwordApple', label: 'Пароль Apple', sensitive: true },
  { name: 'geo', label: 'Гео' },
  { name: 'typeAccount', label: 'Тип аккаунта' },
  { name: 'emailAppsFlyer', label: 'Email AppsFlyer' },
  { name: 'passwordAppsFlyer', label: 'Пароль AppsFlyer', sensitive: true },
  { name: 'emailGmail', label: 'Email Gmail' },
  { name: 'passwordGmail', label: 'Пароль Gmail', sensitive: true },
  { name: 'emailDev', label: 'Email Dev' },
  { name: 'passwordDev', label: 'Пароль Dev', sensitive: true },
  { name: 'emailDevTransfer', label: 'Email Dev Transfer' },
  { name: 'passwordDevTransfer', label: 'Пароль Dev Transfer', sensitive: true },
  { name: 'dateOfTransferToAnotherAccount', label: 'Дата передачи на другой аккаунт', transform: 'dateYMD' },
  { name: 'twoFaDev', label: '2FA Dev', sensitive: true },
  { name: 'twoFA', label: '2FA', sensitive: true },
  { name: 'rental', label: 'Аренда (список)', transform: 'csvToArray' },
  { name: 'linkToApps', label: 'Ссылка на приложения' },
  { name: 'statusAccount', label: 'Статус аккаунта' },
];

/** Поля, которые возвращает getIssueByKey */
export const JIRA_RESPONSE_FIELDS: { name: string; label: string }[] = [
  { name: 'key', label: 'Ключ задачи' },
  { name: 'summary', label: 'Название задачи' },
  { name: 'link', label: 'Ссылка' },
  { name: 'comand', label: 'Команда' },
];

export const JIRA_TRANSFORMS: { value: string; label: string }[] = [
  { value: '', label: 'Как есть' },
  { value: 'csvToArray', label: 'Список через запятую' },
  { value: 'dateYMD', label: 'Дата ГГГГ-ММ-ДД' },
  { value: 'bool', label: 'Да / Нет' },
];